import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=cf04462c&scoped=true&"
import script from "./AdminPanel.vue?vue&type=script&lang=js&"
export * from "./AdminPanel.vue?vue&type=script&lang=js&"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=cf04462c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf04462c",
  null
  
)

export default component.exports